module.exports = {"component":"tooltip","status":"prod","display-name":"Tooltips","classKey":"Tooltip","SLDS-component-path":"/components/tooltips","site-stories":[{"heading":"Base","path":"/__examples__/base.jsx"},{"heading":"Button Trigger","path":"/__examples__/button.jsx"},{"heading":"Button Group Trigger","path":"/__examples__/button-group.jsx"},{"heading":"Learn more","path":"/__examples__/learn-more.jsx"}],"url-slug":"tooltips"}


//////////////////
// WEBPACK FOOTER
// ./~/@salesforce/design-system-react/lib/components/tooltip/component.json
// module id = 174
// module chunks = 0